
import  { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { MmFlexLayoutModule, MmIconModule, MmPaginatorModule } from '@metromarkets/components';
import { VatDisclaimerPLPs } from '~shared/components/vat-disclaimer-plps';
import { IsVisibleModule } from '~shared/directives/is-visible/is-visible.module';
import { MatIconModule } from '@angular/material/icon';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ProductsGridModule } from '~shared/modules/products-grid/products-grid.module';
import { AppProductCarouselModule } from '~shared/components/app-product-carousel/app-product-carousel.module';
import { CategoryCarouselModule } from '~shared/modules/category-carousel/category-carousel.module';

import { CatalogBodyComponent } from './catalog-body.component';
import { ProductListComponent } from './product-list/product-list.component';
import {
  OtherBucketsBannerComponent
} from '~shared/modules/catalog/catalog-products-list/modules/catalog-body/other-buckets-banner/other-buckets-banner.component';
import {
  OutOfScopeCategoryGridComponent
} from '~shared/modules/catalog/catalog-products-list/modules/catalog-body/out-of-scope-category-grid/out-of-scope-category-grid.component';
import {
  ZeroResultSearchComponent
} from '~shared/modules/catalog/catalog-products-list/modules/catalog-body/zero-result-search/zero-result-search.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    QaLocatorsModule,
    MmFlexLayoutModule,
    VatDisclaimerPLPs,
    IsVisibleModule,
    MmPaginatorModule,
    MatIconModule,
    NgxSkeletonLoaderModule,
    ProductsGridModule,
    MmIconModule,
    AppProductCarouselModule,
    CategoryCarouselModule
  ],
  declarations: [
    CatalogBodyComponent,
    OtherBucketsBannerComponent,
    OutOfScopeCategoryGridComponent,
    ProductListComponent,
    ZeroResultSearchComponent
  ],
  exports: [
    CatalogBodyComponent,
    OtherBucketsBannerComponent,
    OutOfScopeCategoryGridComponent,
    ProductListComponent,
    ZeroResultSearchComponent
  ],
})
export class CatalogBodyModule {}
